import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const PlusShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 424 424",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M302 130c-4.4 0-8-3.6-8-8V0H130v122c0 4.4-3.6 8-8 8H0v164h122c4.4 0 8 3.6 8 8v122h164V302c0-4.4 3.6-8 8-8h122V130H302z"
    })
  });
};

export { PlusShape };
//# sourceMappingURL=PlusShape.js.map
